<template>
  <div>
    <table class="table table-striped">
      <thead class="thead-dark">
        <tr>
          <th>Brand Name - Account - Manager Username</th>
          <th>Last Sync Product</th>
          <th v-for="(i, index) of listDate" :key="index">{{ i }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(j, indexj) of dataSet" :key="indexj">
          <td style="text-align: left">{{ j.display_name }}</td>
          <td>
            <template v-if="j.urgent">
              <b style="color: red">{{ j.last_sync_product }}</b>
            </template>
            <template v-else>{{ j.last_sync_product }}</template>
          </td>
          <template v-for="(value, text, indexk) of j">
            <td
              :key="indexk"
              v-if="
                text != 'display_name' &&
                text != 'last_sync_product' &&
                text != 'urgent'
              "
            >
              <template v-if="value > 0">{{ value }}</template>
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { Line } from "vue-chartjs";
import moment from "moment-timezone";

export default {
  extends: Line,
  props: {
    dataListing: Object,

    //listSite: Array,
  },
  data: () => ({
    dataSet: [],
    listDate: [],
  }),
  methods: {
    loadData() {
      var dateTemp = new Set();
      for (const i in this.dataListing) {
        this.dataSet.push(this.dataListing[i]);
        for (const j in this.dataListing[i]) {
          if (
            j != "display_name" &&
            j != "last_sync_product" &&
            j != "urgent"
          ) {
            dateTemp.add(j);
          }

          if (j == "last_sync_product") {
            var current = moment(new Date());
            var a =
              (current - new Date(this.dataListing[i][j])) / (1000 * 3600);

            if (a >= 24) {
              this.dataListing[i]["urgent"] = true;
            } else {
              this.dataListing[i]["urgent"] = false;
            }

            this.dataListing[i][j] = moment(this.dataListing[i][j]).fromNow();
          }
        }
      }
      this.listDate = Array.from(dateTemp);
      console.log("this.dataSet: ", this.dataSet);
      console.log("listDate: ", this.listDate);
    },
  },
  mounted() {
    this.loadData();
    // console.log('this.dataSetSite: ',this.dataSetSite)
    // console.log('this.listDate: ',this.listDate)
  },
};
</script>